import dayjs from 'dayjs';
import 'dayjs/locale/en-nz';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import debounce from 'debounce-promise';
import { createBrowserHistory, History } from 'history';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.min.css';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';
import 'react-table-6/react-table.css';
import { PreloadedState } from 'redux';
import * as api from './api';
import App from './App';
import { PopperProvider } from './Components/PortalPopper';
import { storageItem } from './dom-utils';
import './index.scss';
import { configureStore } from './store';
import { StoreState } from './store/types';
import TeamsProvider from './TeamsProvider';

function applyProviders(...providers: React.ReactElement[]) {
  return providers.reduceRight((child, parent) => React.cloneElement(parent, { children: child }))
}

const prevLocation = storageItem<string>(sessionStorage, 'prevLocation')
let history: History<any>

function init() {
  if (document.getElementsByTagName('base').length === 0) {
    console.log('[index.tsx] Redirecting to logout')
    redirectToLogout()
    return
  }

  const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!
  api.setBaseUrl(baseUrl)
  console.log('[index.tsx] Set baseUrl to ', baseUrl)

  history = createBrowserHistory({
    basename: baseUrl.replace(/\/+$/, ''),
  })


  console.log('[index.tsx] In init() window.location.search', window.location.search)

  const id = new URLSearchParams(window.location.search).get('ipfx-id')
  if (id) {
    api.setClientId(id)
  }
  render()
}

function render() {
  dayjs.extend(utc)
  dayjs.extend(customParseFormat)
  dayjs.extend(localizedFormat)
  //dayjs.locale('en-nz')

  const pathname = prevLocation.get()
  if (pathname) {
    console.log('[index.tsx] Found previous location, replacing history', pathname)
    prevLocation.del()
    history.replace(pathname)
  }

  if (history.location.pathname === '/Default.aspx') {
    console.log('[index.tsx] Found pathname /Default.aspx setting to /', history.location)

    history.replace('/')
  }

  const store = initStore({});
  const root = document.getElementById('root')

  ReactModal.setAppElement(root!)
  ReactModal.defaultStyles.content = {}

  ReactDOM.render(applyProviders(
    <Router history={history} />,
    <ReduxProvider store={store} />,
    <TeamsProvider />,
    <PopperProvider />,
    <DndProvider backend={Backend} />,
    <App />,
  ), root)
}

init()

function initStore(preloadedState: PreloadedState<StoreState>) {
  const localSettings = storageItem<StoreState['localSettings']>(localStorage, 'localSettings')
  let previousLocalSettings = localSettings.get()

  const store = configureStore({
    ...preloadedState,
    localSettings: previousLocalSettings,
  }, history)

  store.subscribe(debounce(() => {
    const state = store.getState().localSettings
    if (state !== previousLocalSettings) {
      previousLocalSettings = state
      localSettings.set(state)
    }
  }, 1000, { leading: true }))

  return store;
}

export function redirectToLogin(query: string) {
  console.log(`[index.tsx] redirectToLogin: query=${query}`, { ...window.location })

  let searchParams = new URLSearchParams(query)

  const ext = searchParams.get('e')
  searchParams.delete('e')
  const pin = searchParams.get('p')
  searchParams.delete('p')
  const loginParams = ext && pin ? `&e=${ext}&p=${pin}` : ''

  const savedLocation = `${history.location.pathname}?${searchParams.toString()}`
  prevLocation.set(savedLocation)
  console.log(`[index.tsx] saved location for return [${savedLocation}]`)

  const href = api.getApiUrl(`/Login.aspx?redirect=${api.getUrl('Default.aspx', false)}${loginParams}`)
  window.location.href = href
}

export function redirectToLogout() {
  window.location.href = api.getApiUrl(`/Logout.aspx?redirect=${api.getUrl('Default.aspx', false)}`)
}

export type Result = {
  success: boolean
  data: string
  error: string
}
